import { RestClient } from "clients/rest";

export type B100150FindRequest = {
  torihikiCd: string;
  torihikishitenCd: string;
} & Partial<{
  kikanymd: string;
  shohinCdFrom: string;
  shohinCdTo: string;
  shodaibunFrom: string;
  shodaibunTo: string;
  shochubunFrom: string;
  shochubunTo: string;
  shoshobunFrom: string;
  shoshobunTo: string;
}>;

export type B100150FindResponse = {
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  shohinNm: string;
  aiteCd: string;
  kikanFromymd: string;
  tanka: string;
  jodaitanka: string;
  version: number;
};

export const B100150Find = (props: B100150FindRequest) => {
  return RestClient.get<B100150FindResponse[]>("b100150/find", {
    params: props,
  });
};

export type B100150CreateRequest = {
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  kikanFromymd: string;
} & Partial<{
  aiteCd: string;
  ediShohinCd: string;
  tanka: string;
  jodaitanka: string;
}>;

export const B100150Create = (data: B100150CreateRequest) => {
  return RestClient.post("b100150/create", data);
};

export type B100150UpdateRequest = {
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  defaultKikanFromymd: string;
  kikanFromymd: string;
  version: number;
} & Partial<{
  aiteCd: string;
  ediShohinCd: string;
  tanka: string;
  jodaitanka: string;
}>;

export const B100150Update = (data: B100150UpdateRequest) => {
  return RestClient.put("b100150/update", data);
};

export type B100150DeleteRequest = {
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  kikanFromymd: string;
};

export const B100150Delete = (data: B100150DeleteRequest) => {
  return RestClient.delete("b100150/delete", { data: data });
};
